import { checkIfFlagIsToggled } from '@famly/vet_ts-utils_local-storage-config';
import { useKinderConnectCaptureFlagsQuery } from '@famly/stat_kinder-connect-capture_data';
import { useIsKinderConnectCaptureEnabled } from '../use-is-kinder-connect-capture-enabled';
/**
 * Whether KinderConnect (TWC) capture management should be available at this site -- i.e. it
 * qualifies for the site-level fallback flag (a Texas site with the feature enabled), or the
 * `KINDER_CONNECT_CAPTURE` debug flag is on.
 *
 * This only decides whether to show the management UI. It says nothing about whether a specific
 * child needs capture on check-in/check-out -- use `useIsKinderConnectCaptureEnabledForChildren`
 * or `useKinderConnectCaptureGate` for that, which ask per child.
 *
 * @param siteId - The site to check.
 * @returns Whether capture management is available at this site, and whether that answer is
 * still pending -- see `isLoading`.
 */
export const useIsKinderConnectCaptureManagementAvailableForSite = (siteId) => {
    var _a;
    const kinderConnectCaptureFlagsQuery = useKinderConnectCaptureFlagsQuery({
        variables: { siteId },
        skip: !siteId,
    });
    const isEnabled = useIsKinderConnectCaptureEnabled((_a = kinderConnectCaptureFlagsQuery.data) === null || _a === void 0 ? void 0 : _a.attendance.childCheckins.kinderConnectCapture.captureEnabled);
    return {
        isEnabled,
        isLoading: kinderConnectCaptureFlagsQuery.loading && !checkIfFlagIsToggled('KINDER_CONNECT_CAPTURE'),
    };
};
